<template>
  <div id="page-wrapper-nav">
    <app-header/>
    <router-view></router-view>
    <app-footer/>
    <page-loader/>
    <modal-overlay :class="{active: showModal}" />
  </div>
</template>

<script>
import Header from 'components/Header'
import Footer from 'components/Footer'
import PageLoader from 'components/PageLoader'
import ModalOverlay from 'components/modal/ModalOverlay'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'PageWrapperNav',
  components: {
    appHeader: Header,
    appFooter: Footer,
    PageLoader,
    ModalOverlay
  },
  computed: {
    ...mapState({
      showModal: state => state.modal.showModal
    })
  },
  methods: {
    ...mapMutations([
      'UPDATE_USER_ACTIVE',
      'UPDATE_TOUCH_DEVICE'
    ])
  },
  mounted: function () {
    var self = this
    var mouse = 0
    var timer

    // Detect touch device
    function detect () {
      if (mouse > 1) {
        document.body.classList.remove('touch-device')
        document.body.classList.add('disabled-card-animation')
        self.UPDATE_USER_ACTIVE(true)
        self.UPDATE_TOUCH_DEVICE(false)
        clearTimeout(timer)
        timer = setTimeout(function () {
          document.body.classList.remove('disabled-card-animation')
          self.UPDATE_USER_ACTIVE(false)
        }, 50)
      } else {
        document.body.classList.add('touch-device')
        document.body.classList.remove('disabled-card-animation')
        self.UPDATE_TOUCH_DEVICE(true)
      }
    }
    window.addEventListener('mousemove', function (e) {
      if (mouse < 2) {
        mouse++
      }
      detect()
    })
    window.addEventListener('touchstart', function (e) {
      mouse = 0
      detect()
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/sections/_PageWrapperNav.vue